module.exports = __webpack_public_path__ + "static/organicorangegeometric-14d0ad57ed4ac0e88aa001358b0dcce9.jpeg";